import React from "react";
import Layout from '../../components/layout';
import MainContent from '../../components/maincontent';
import Seo from "../../components/seo";

const IndexPage = () => {


  return (
    <Layout>
      <Seo 
        title={`Camp 2026 - Schedule`}
        description={`Schedule for Charity Grace Bible Camp 2026`}
        lang="en"
        meta={[
          {
            content: "God, Jesus, Gospel, Heaven, Salvation, Saved, Grace, Free, How, Mid-Acts, Romans, Charity Grace Bible Church, Illinois",
            name: "keywords"
          }
        ]}
      />

      <MainContent hasArticle={false} hasBanner={false}>
        

        <div className="grid--14 grid-padding align--center">
          <h1>Special Thanks to everyone involved in keeping camp going and running smoothly year after year!</h1>
        </div>
        <div className="grid--12 grid-padding align--left">
          <h3>Thank you most of all to Barny and Mary for hosting camp and bringing us all together year after year!</h3>
        </div>
        <div className="grid--12 grid-padding align--left">
          <h3>Thank you to Robyn Luethge for running the kitchen and keeping us all well fed!</h3>
        </div>
        <div className="grid--12 grid-padding align--left">
          <h3>Thank you to Kadee Luethge for taking the photos and managing all of the registration and making sure we all have somewhere to sleep!</h3>
        </div>
        <div className="grid--12 grid-padding align--left">
          <h3>Thank you to Luke Vigue for recording the messages and meetings and posting them where they can be seen online!</h3>
        </div>
      </MainContent>
    </Layout>
  );
};


export default IndexPage;